import { defineMessages } from 'react-intl';

export const warningHeaders = defineMessages({
  alcohol: {
    id: 'inbox.warning_headers.alcohol',
    defaultMessage: 'This booking includes alcohol'
  },
  lateNight: {
    id: 'inbox.warning_headers.late_night',
    defaultMessage: 'This is a late night booking'
  },
  alcoholAndLateNight: {
    id: 'inbox.warning_headers.alcohol_and_late_night',
    defaultMessage: 'Late night booking with alcohol'
  }
});
